/**
 * 判断是否为外部资源
 * @param path 路径
 */
export function isExternal(path:string):boolean{
    return /^(https?:|http:|tel:|mailto:)/.test(path)
}